module.exports = __webpack_public_path__ + "static/media/en.5db9fea0.svg";